import axios from "axios";
import {
  LOADING_REQUEST,
  LOADING_SUCCESS,
} from "../Constants/LoadingConstants";

import {
  JOB_LIST_REQUEST,
  JOB_LIST_SUCCESS,
  JOB_LIST_FAIL,
  CATEGORY_BASED_REQUEST,
  CATEGORY_BASED_SUCCESS,
  CATEGORY_BASED_FAIL,
} from "../Constants/JobConstants";

const baseUrl = process.env.REACT_APP_API_URL;

export const categoryBasedJob = (value) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CATEGORY_BASED_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.get(
      `${baseUrl}/api/category/${value}`,
      config
    );

    dispatch({
      type: CATEGORY_BASED_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_BASED_FAIL,
      payload: error.response && error.response.data ? error.response.data : "",
    });
  }
};

export const jobsListFront = (search) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (typeof search == "undefined") {
      search = "";
    }
    const { data } = await axios.get(
      `${baseUrl}/api/sample/jobsListFront?search=${search}`,
      config
    );

    dispatch({
      type: JOB_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: JOB_LIST_FAIL,
      payload: error.response && error.response.data ? error.response.data : "",
    });
  }
};

export const jobsCoverListFront = (search) => async (dispatch, getState) => {
  try {
    dispatch({
      type: JOB_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (typeof search == "undefined") {
      search = "";
    }
    const { data } = await axios.get(
      `${baseUrl}/api/sample/cover/jobsListFront?search=${search}`,
      config
    );

    dispatch({
      type: JOB_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: JOB_LIST_FAIL,
      payload: error.response && error.response.data ? error.response.data : "",
    });
  }
};
